/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_JapaneseInputs */

const en_speechmatics_target_language_japanese = /** @type {(inputs: Speechmatics_Target_Language_JapaneseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Japanese`)
};

const fr_speechmatics_target_language_japanese = /** @type {(inputs: Speechmatics_Target_Language_JapaneseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Japonais`)
};

const de_speechmatics_target_language_japanese = /** @type {(inputs: Speechmatics_Target_Language_JapaneseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`japanisch`)
};

const it_speechmatics_target_language_japanese = /** @type {(inputs: Speechmatics_Target_Language_JapaneseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`giapponese`)
};

const ru_speechmatics_target_language_japanese = /** @type {(inputs: Speechmatics_Target_Language_JapaneseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`японский`)
};

const es_speechmatics_target_language_japanese = /** @type {(inputs: Speechmatics_Target_Language_JapaneseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`japonés`)
};

const zh_cn2_speechmatics_target_language_japanese = /** @type {(inputs: Speechmatics_Target_Language_JapaneseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本人`)
};

const ja_speechmatics_target_language_japanese = /** @type {(inputs: Speechmatics_Target_Language_JapaneseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const hi_speechmatics_target_language_japanese = /** @type {(inputs: Speechmatics_Target_Language_JapaneseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जापानी`)
};

const pt_pt2_speechmatics_target_language_japanese = /** @type {(inputs: Speechmatics_Target_Language_JapaneseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`japonês`)
};

/**
* | output |
* | --- |
* | "Japanese" |
*
* @param {Speechmatics_Target_Language_JapaneseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_japanese = /** @type {((inputs?: Speechmatics_Target_Language_JapaneseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_JapaneseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_japanese(inputs)
	if (locale === "de") return de_speechmatics_target_language_japanese(inputs)
	if (locale === "it") return it_speechmatics_target_language_japanese(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_japanese(inputs)
	if (locale === "es") return es_speechmatics_target_language_japanese(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_japanese(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_japanese(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_japanese(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_japanese(inputs)
	return en_speechmatics_target_language_japanese(inputs)
});